import React, { useReducer, useContext, useEffect } from 'react'
import { lockedReducer } from '../Utils/reducers';
import { api } from '../../services/api';
import { externalComponent } from '../AppRoutes';
import validateData from "./validateData";
import { Box, Tooltip, TextField } from '@mui/material'
import DefaultModal from '../Utils/DefaultModal';
import ColorButton from '../Buttons/ColorButton';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import FormControlLabel from '@mui/material/FormControlLabel';
import IOSSwitch from '../Utils/Switch';
import MegaAutoComplete from '../Utils/megautocomplete';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';


const url = '/credenciado/'

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Credenciado ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Credenciado não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: ${res.data}`)
    setLoader(false)
}

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const switchStatus = (value) => {
    let status = 'T'
    if (value === false) {
        status = 'F'
    }
    return status
}

const changeStatusBool = (value) => {
    if (value === 'T') {
        return true
    } else {
        return false
    }
}

const loadRetrieve = async (setState, setLoader, data) => {
    setLoader(true)
    const res = await api.post(`${url}complete/`, data)
    if (res.status === 200) {
        setState({ ...res.data })
    }
    setLoader(false)
}

const EditCredenciado = ({ data, handleClose, reloadData }) => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        nome: '',
        cartao: '',
        validadeinicial: '',
        validadefinal: '',

        switch_ativo: true,
        valido: 'T',

        switch_facility: false,
        facility: 'F',

        switch_chuveiro: false,
        chuveiro: 'F',

        acesso: null,

        ...data,
        id: data.id ? data.id : 0
    })

    const validData = validateData(state)

    useEffect(() => {

        setState({
            switch_ativo: changeStatusBool(state.valido), switch_facility: changeStatusBool(state.facility),
            switch_chuveiro: changeStatusBool(state.chuveiro)
        })

        console.log(data)

        if (data.cartao)
            loadRetrieve(setState, setLoader, state)

    }, [data.id])

    return (
        <>
            <DefaultModal
                dialogProps={{
                    sx: {
                        '& .MuiPaper-root': {
                            maxWidth: 'unset',
                            maxHeight: 'unset',
                            width: '45%',
                            height: '70%',
                            margin: '0px',

                            '@media (min-width: 1600px)': {
                                width: '50%', // Largura para telas maiores
                                height: '70%', // Altura para telas maiores
                            },
                        }
                    }
                }}
                open={true}
                title={
                    `${getTitle(state)} Credenciado`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' >

                            <Stack sx={{ width: '100%', marginBottom: '1rem', gap: '1rem' }} spacing={2}>
                                <Alert sx={{ width: '100%!important' }} severity="info">
                                    {'Se o campo "Num. Cartão" estiver vazio será cadastrado com número autogerado.'}
                                </Alert>
                            </Stack>


                            <Box className='item-profile-row'>

                                {
                                    state.id !== 0 ?
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            Status:
                                            <FormControlLabel
                                                control={<IOSSwitch sx={{ m: 1 }} checked={state.switch_ativo} onChange={() => setState({ valido: switchStatus(!state.switch_ativo), switch_ativo: !state.switch_ativo })} />}
                                                label={state.valido === 'F' ? 'Desativado' : 'Ativado'}
                                            />
                                        </Box>
                                        :
                                        null
                                }

                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    Facility:
                                    <FormControlLabel
                                        control={<IOSSwitch sx={{ m: 1 }} checked={state.switch_facility} onChange={() => setState({ facility: switchStatus(!state.switch_facility), switch_facility: !state.switch_facility })} />}
                                        label={state.facility === 'F' ? 'Desativado' : 'Ativado'}
                                    />
                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    Chuveiro:
                                    <FormControlLabel
                                        control={<IOSSwitch sx={{ m: 1 }} checked={state.switch_chuveiro} onChange={() => setState({ chuveiro: switchStatus(!state.switch_chuveiro), switch_chuveiro: !state.switch_chuveiro })} />}
                                        label={state.chuveiro === 'F' ? 'Desativado' : 'Ativado'}
                                    />
                                </Box>
                            </Box>

                            <Box className='item-profile-row'>
                                <TextField
                                    id="name"
                                    type="text"
                                    label="Num. Cartão"
                                    value={state.cartao}
                                    onChange={(e) => { setState({ 'cartao': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>

                            <Box className='item-profile-row'>
                                <TextField
                                    id="name"
                                    type="text"
                                    label="Nome"
                                    value={state.nome}
                                    onChange={(e) => { setState({ 'nome': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>

                            <Box className='item-profile-row'>

                                <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    label="Validade Inicial:"
                                    size="small"
                                    value={state.validadeinicial ? dayjs(state.validadeinicial) : null}
                                    onChange={(e) => {
                                        setState({ validadeinicial: e ? e.format('YYYY-MM-DD') : '' });
                                    }}
                                    format="DD/MM/YYYY"
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    ampm={false}
                                />


                                <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    label="Validade Final:"
                                    size="small"
                                    value={state.validadefinal ? dayjs(state.validadefinal) : null}
                                    onChange={(e) => {
                                        setState({ validadefinal: e ? e.format('YYYY-MM-DD') : '' });
                                    }}
                                    format="DD/MM/YYYY"
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    ampm={false}
                                />

                            </Box>

                            <Box>
                                <MegaAutoComplete
                                    multiple={false}
                                    value={state.acesso}
                                    onChange={(data) => setState({ acesso: data })}
                                    noOptionsText={'Digite para procurar um acesso'}
                                    timeoutUrl='/acessos/complete/'
                                    timeoutParam='label'
                                    label='Acesso'
                                    sx={{ width: '20%' }}
                                />
                            </Box>

                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />
        </>
    )
}

export default EditCredenciado;